/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Col, DatePicker, Form, Input, Radio, Row, Select, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import dayjs from 'dayjs';

import { ReactComponent as Picker } from '../../../assets/date-picker-icon.svg';
import { ReactComponent as Attached } from '../img/attached.svg';
import { ReactComponent as DelImage } from '../img/del-cross-icon.svg';
import { ReactComponent as Pluse } from '../../../assets/pluse-black-icon.svg';
import { ReactComponent as Delete } from '../../../assets/delete-black-icon.svg';


import CustomRadioButton from '../../../components/CustomRadioButton/CustomRadioButton';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';
// import CustomPhoneInput from '../../../components/CustomPhoneInput/CustomPhoneInput';
import CustomInputNumber from '../../../components/CustomInputNumber/CustomInputNumber';
import { CustomTextarea } from '../../../components/CustomTextfield/CustomTextfield';
import CustomCheckbox from '../../../components/CustomCheckbox/CustomCheckbox';
import { deleteAttachedDocuments, getOnboardingById, uploadOnboardingDocument } from '../../../data/store/onboarding/onboardingActions';
import { useDispatch, useSelector } from 'react-redux';
import OnboardingFileViewer from '../OnboardingFileViewer/OnboardingFileViewer';
import api from '../../../utils/API';
import { decimalSeparator as decFunc } from '../../../helpers/decimalSeparator';
import { API_URLS } from '../../../constants/api_urls';
import { getValueObj } from '../OnboardingCategory';
import { formatter, parser } from '../../../helpers/formatterInput';

/** Ant Design DatePicker + Form ожидают dayjs или undefined; иначе падает date.isValid в useInvalidate */
const normalizePickerFormValue = (val) => {
  if (val == null || val === '') {
    return undefined;
  }
  if (typeof val === 'object' && typeof val.isValid === 'function') {
    return val.isValid() ? val : undefined;
  }
  const parsed = dayjs(val);
  return parsed.isValid() ? parsed : undefined;
};

const OnboardingItemFabrica = ({
  form,
  formItem,
  getNameByCode,
  getPath,
  notEditable,
  composite = null,
  multiName = null,
  /** Табличный композит: значения уходят на бэк только по кнопке сохранения строки, не по blur/change */
  deferRemoteSubmit = false,
  /** Не-table композит: вместо itemSubmit вызывается после blur/изменения (валидация строки — в родителе) */
  onDeferredBlur,
}) => {
  console.log('🚀 ~ OnboardingItemFabrica ~ notEditable:', notEditable);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { onboardingById, uploadDocs, directory } = useSelector(state => state.onboardingReducer);

  const decimalSeparator = decFunc();

  /*
  const obj = {
    form_input_element_id: item,
    form_submission_id: onboardingById?.id,
    [type?.valueType?.toLowerCase()]: i,
  };
  */
  const createFormInputElement = async(data) => {
    return await api.post(API_URLS.CREATE_FORM_INPUT_ELEMENT_V3, data);
  };
  const editInputElement = async(data) => {
    const { id, ...rest } = data;
    return await api.put(API_URLS.EDIT_FORM_INPUT_ELEMENT_V3(id), rest);
  };
  const deleteInputElement = async(id) => {
    return await api.delete(API_URLS.EDIT_FORM_INPUT_ELEMENT_V3(id));
  };

  const getFieldName = () => {
    if (multiName !== null) {
      return [multiName, formItem?.id];
    }
    if (composite) {
      return [composite, formItem?.id];
    }
    return formItem?.field_name;
  };

  const name = getFieldName();

  /** Полный namePath в корневой форме (для validateFields одного затронутого поля) */
  const fullValidationPath = useMemo(() => {
    if (composite != null && multiName !== null) {
      const n = name;
      return Array.isArray(n) ? [composite, ...n] : [composite, multiName, n];
    }
    return name;
  }, [composite, multiName, name]);

  const invokeDeferredBlur = useCallback(
    async (blurFieldPath) => {
      if (onDeferredBlur) {
        await onDeferredBlur(blurFieldPath ?? fullValidationPath);
      }
    },
    [fullValidationPath, onDeferredBlur],
  );

  const itemSubmit = async(value, checked = true, multiValue = false, formDataId = null, update = false) => {
      if (deferRemoteSubmit) {
        return;
      }
      const storedItem = onboardingById?.form_input_element_submissions?.find(i => i.form_input_element_id === formItem.form_input_element.id);
      const typeItem = getValueObj(formItem.form_input_element, value);

      let statusElement = storedItem && !multiValue 
        ? (checked 
          ? 'edit' 
          : 'delete') 
        : !value
          ? 'delete'
          : multiValue === 'several' 
            ? formDataId ? 'edit' : 'new'
            : multiValue && !checked
              ? 'delete'
              : 'new';
      console.log('🚀 ~ itemSubmit ~ statusElement:', statusElement);

      const obj = {
        ...typeItem,
        form_input_element_id: formItem.form_input_element.id,
        form_submission_id: onboardingById?.id,
      };

      if(statusElement === 'new') {
        try {
          await createFormInputElement(obj);
          dispatch(getOnboardingById(onboardingById?.id));
        } catch (error) {
          const message = error?.response?.data?.form_input_element_validation_errors
          ?.find(i => i.form_input_element_id === formItem.form_input_element.id)?.message;
          console.log('response error',message ?? 'Error validate field');
          form.setFields([
            {
              name: name,
              errors: [message],
            },
          ]);
        }
      } else if(statusElement === 'edit') {
        obj.id = storedItem?.id;
        try {
          await editInputElement(obj);
          update && dispatch(getOnboardingById(onboardingById?.id));
        } catch (error) {
          const message = error?.response?.data?.form_input_element_validation_errors
          ?.find(i => i.form_input_element_id === formItem.form_input_element.id)?.message;
          console.log('response error',message ?? 'Error validate field');
          form.setFields([
            {
              name: name,
              errors: [message],
            },
          ]);
        }
      } else if(statusElement === 'delete') {
        const key = Object.keys(typeItem)[0];
        const hasDelete = onboardingById?.form_input_element_submissions
          ?.filter(i => i.form_input_element_id === formItem.form_input_element.id)
          ?.find(j => j[key] === typeItem[key]);
        if(hasDelete || formDataId) {
          try {
            await deleteInputElement(formDataId ?? hasDelete?.id);
            update && dispatch(getOnboardingById(onboardingById?.id));
          } catch (error) {
            const message = error?.response?.data?.form_input_element_validation_errors
            ?.find(i => i.form_input_element_id === formItem.form_input_element.id)?.message;
            console.log('response error',message ?? 'Error validate field');
            form.setFields([
              {
                name: name,
                errors: [message],
              },
            ]);
          }
        }
      }
    };
  
  const Date = () => {
    const handleChange = (data) => {
      if (!deferRemoteSubmit) {
        itemSubmit(data);
      }
    };
    const handleBlur = async () => {
      if (deferRemoteSubmit && onDeferredBlur) {
        await invokeDeferredBlur();
      }
    };
    return (
      <Form.Item
        label={formItem?.description}
        className={
          formItem?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        name={name}
        rules={[
          {
            required:
              formItem?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
        normalize={normalizePickerFormValue}
        getValueProps={(v) => ({ value: normalizePickerFormValue(v) })}
      >
        <DatePicker
          className="custom-datepicker"
          suffixIcon={<Picker />}
          placeholder={formItem?.hint}
          format="YYYY-MM-DD"
          onChange={(data) => handleChange(data)}
          onBlur={handleBlur}
        />
      </Form.Item>
    );
  };

  const DateTime = () => {
    const handleChange = (data) => {
      if (!deferRemoteSubmit) {
        itemSubmit(data);
      }
    };
    const handleBlur = async () => {
      if (deferRemoteSubmit && onDeferredBlur) {
        await invokeDeferredBlur();
      }
    };
    return (
      <Form.Item
        label={formItem?.description}
        className={
          formItem?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        name={name}
        rules={[
          {
            required:
              formItem?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
        normalize={normalizePickerFormValue}
        getValueProps={(v) => ({ value: normalizePickerFormValue(v) })}
      >
        <DatePicker
          className="custom-datepicker"
          showTime={{ format: 'HH:mm', secondStep: 60 }}
          suffixIcon={<Picker />}
          placeholder={formItem?.hint}
          format="YYYY-MM-DD"
          onChange={(data) => handleChange(data)}
          onBlur={handleBlur}
        />
      </Form.Item>
    );
  };

  const ListFixed = () => {
    const multiValue = !Object.hasOwn(formItem, 'max_number_of_submissions') ||
      formItem?.max_number_of_submissions === null;
    
    const options = formItem?.options?.display_options?.map((i, index) => {
      return {
        label: i,
        value: formItem?.options?.options?.[index],
      };
    });

    const handleChange = (e, value) => {
      if (deferRemoteSubmit && onDeferredBlur) {
        if (multiValue) {
          void invokeDeferredBlur([
            ...(composite != null ? [composite] : []),
            ...(Array.isArray(name) ? name : [name]),
            value,
          ]);
        } else {
          void invokeDeferredBlur();
        }
        return;
      }
      if(multiValue) {
        itemSubmit(value, e.target.checked, multiValue);
      } else {
        itemSubmit(e.target.value);
      }
    };

    return (
      multiValue 
      ? (
        <div className="onboarding-checkbox-group">
          <p>{formItem?.description}{formItem?.min_number_of_submissions === 1 ? ' *' : ''}</p>
          {options?.map((i) => (
            <Form.Item
              key={i?.value}
              name={[name, i.value]}
              valuePropName="checked"
              className={
                'filter-check-item' +
                  formItem?.min_number_of_submissions ===
                1
                  ? 'custom-required'
                  : ''
              }
              required={false}
            >
              <CustomCheckbox onChange={(e) => handleChange(e, i.value)}>
                {i?.label}
              </CustomCheckbox>
            </Form.Item>
          ))}
        </div>
        )
      : (

      <Form.Item
        label={formItem?.description}
        name={name}
        required={false}
        className={formItem?.min_number_of_submissions === 1
            ? 'custom-required radio-acc-type'
            : 'radio-acc-type'}
        rules={[
          {
            required:
              formItem?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
      >
        <Radio.Group value={null} className="onboarding-radiogroup">
          <Space direction="vertical" align="start">
            {options?.map((i) => (
              <CustomRadioButton
                key={i?.value}
                className={'client-signup'}
                value={i?.value}
                onChange={handleChange}
              >
                {i?.label}
              </CustomRadioButton>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>
      )
    );
  };

  const Text = () => {

    const handleChange = (e) => {
        const { value } = e.target;
        console.log('🚀 ~ handleChange ~ value:', value);
      };

    return (
      <Form.Item
        label={getNameByCode(formItem?.code)}
        name={name}
        className={
          formItem?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.min_number_of_submissions === 1 && !formItem?.readonly,
            message: t('ENTER_DATA'),
          },
          {
            min: formItem?.min_text_length,
            message: t('MIN_LENGTH_VALUE') +': ' + formItem?.min_text_length,
          },
          {
            max: formItem?.max_text_length,
            message: t('MAX_LENGTH_VALUE') +': ' + formItem?.max_text_length,
          },
        ]}
        required={false}
      >{Object.hasOwn(formItem, 'min_number_of_submissions') &&
        formItem?.min_number_of_submissions !== null &&
        (
          <Input
            placeholder={formItem?.hint}
            className="custom-input full-width"
            maxLength={formItem?.max_text_length}
            minLength={formItem?.min_text_length}
            readOnly={formItem?.readonly}
            onChange={handleChange}
          />
        )
      }
      </Form.Item>
    );
  };

  const Typography = () => {
    return (
      <Form.Item
        label={formItem?.description}
      >
      </Form.Item>
    );
  };

  const ListDynamic = () => {
    const multiValue = !Object.hasOwn(formItem, 'max_number_of_submissions') ||
      formItem?.max_number_of_submissions === null;
    const options = useMemo(() => {
      if(formItem?.options_directory) {
        return directory?.[formItem?.options_directory?.name]?.map((i) => {
          return {
            id: i[formItem?.options_directory?.id],
            label: i[formItem?.options_directory?.label],
            value: i[formItem?.options_directory?.value],
          };
        });
      } else {
        return formItem?.options?.display_options?.map((i, index) => {
          return {
            label: i,
            value: formItem?.options?.options?.[index],
          };
        }) || [];
      }
    }, [formItem?.options?.display_options, formItem?.options?.options]);

    const handleChange = (value) => {
    console.log('🚀 ~ handleChange ~ value:', value);
    };
    const handleDeselect = (value) => {
    console.log('🚀 ~ handleDeselect ~ value:', value);
    };
    
    return (
      <Form.Item
        label={getNameByCode(formItem?.code)}
        name={name}
        className={
          formItem?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
      >
        <CustomSelect
          mode={multiValue ? 'multiple' : 'default'}
          width={'100%'}
          placeholder={formItem?.hint}
          className="custom-select"
          showSearch
          filterOption={(inputValue, option) => {
            return inputValue?.length > 1
              ? option?.children?.props?.children
                  ?.toUpperCase()
                  ?.indexOf(inputValue?.toUpperCase()) !== -1
              : true;
          }}
          notFoundContent={<></>}
          onSelect={handleChange}
          onDeselect={handleDeselect}
        >
          {options?.map((item) => {
            return (
              <Select.Option key={item.id} value={item.value}>
                {item?.label}
              </Select.Option>
            );
          })}  
        </CustomSelect>
      </Form.Item>
    );
  };

  // const PhoneNumber = () => {
  //   return (
  //     <Form.Item
  //       label={formItem?.description}
  //       name={name}
  //       className={
  //         formItem?.min_number_of_submissions === 1
  //           ? 'custom-required'
  //           : ''
  //       }
  //       rules={[
  //         {
  //           required:
  //             formItem?.min_number_of_submissions === 1,
  //           message: t('ENTER_PHONE_NUMBER'),
  //         },
  //       ]}
  //       required={false}
  //     >
  //       <CustomPhoneInput
  //         popupClassName="onboarding-custom-inputnumber-dropdown"
  //         nameCode={[name, 'country_code']}
  //         width="100%"
  //       />
  //     </Form.Item>
  //   );
  // };
  const Email = () => {
    const multiValue = formItem?.max_number_of_submissions === null ||
      formItem?.max_number_of_submissions !== 1 ||
      !Object.hasOwn(formItem, 'max_number_of_submissions');

    // const handleRemove = (fieldIndex) => {
    // console.log('🚀 ~ handleRemove ~ fieldIndex:', fieldIndex);
    // };

    return (
      !multiValue
      ? (
        <Form.Item
          label={t(formItem?.description)}
          name={name}
          className={
            formItem?.min_number_of_submissions === 1
              ? 'custom-required'
              : ''
          }
          rules={[
            {
              required:
                formItem?.min_number_of_submissions === 1 && !formItem?.readonly,
              message: t('ENTER_EMAIL_ADDRESS'),
            },
            {
              type: 'email',
              message: t('ENTER_EMAIL_ADDRESS'),
            },
          ]}
          required={false}
        >
          <Input
            placeholder={formItem?.hint}
            className="custom-input full-width"
            maxLength={formItem?.max_text_length}
            minLength={formItem?.min_text_length}
          />
        </Form.Item>
      )
      : (
        <div className="onboarding-multi-input">
          <p>{t(formItem?.description)}{formItem?.min_number_of_submissions === 1 ? ' *' : ''}</p>
          <Form.List name={name}>
            {(fields, { add, remove }) =>{
              return (
              <>
                {fields.map(({ key, name: fieldIndex }) => (
                  <Row key={key}>
                    <Col span={21}>
                      <Form.Item
                        key={key}
                        name={[fieldIndex]}
                        className={
                          formItem?.min_number_of_submissions === 1
                            ? 'custom-required'
                            : ''
                        }
                        rules={[
                          {
                            required:
                              formItem?.min_number_of_submissions === 1 && !formItem?.readonly,
                            message: t('ENTER_EMAIL_ADDRESS'),
                          },
                          {
                            type: 'email',
                            message: t('ENTER_EMAIL_ADDRESS'),
                          },
                        ]}
                        required={false}
                      >
                        <Input
                          placeholder={formItem?.hint}
                          className="custom-input full-width"
                          maxLength={formItem?.max_text_length}
                          minLength={formItem?.min_text_length}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={3}  className="onboarding-delete-btn-wrapper" style={{alignItems: 'center', paddingBottom: '0'}}>
                      <Delete 
                        className='onboarding-delete-btn'
                        onClick={notEditable ? undefined : () => remove(fieldIndex)} />
                    </Col>
                  </Row>
                ))}
                <div>
                  <Button
                    disabled={notEditable}
                    type="text"
                    icon={<Pluse />}
                    iconPosition="end"
                    className="profile-data-addbutton"
                    onClick={() => add()}
                  >
                    {t('ADD')}
                  </Button>
                </div>
              </>
            );}}
          </Form.List>

        </div>
      )
    );
  };

  const Url = () => {

    return (
      <Form.Item
        label={formItem?.description}
        name={name}
        className={
          formItem?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.min_number_of_submissions === 1 && !formItem?.readonly,
            message: t('ENTER_VALID_URL'),
          },
          {
            type: 'url',
            message: t('ENTER_VALID_URL'),
          },
        ]}
        required={false}
      >
        <Input
          placeholder={formItem?.hint}
          className="custom-input full-width"
          maxLength={formItem?.max_text_length}
          minLength={formItem?.min_text_length}
        />
      </Form.Item>
    );
  };

  const Number = () => {

    return (
      <Form.Item
        label={formItem?.description}
        name={name}
        className={
          formItem?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.min_number_of_submissions === 1 && !formItem?.readonly,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
      >
        <CustomInputNumber
          width={'100%'}
          placeholder={formItem?.hint}
          min={formItem?.min_number_value}
          readOnly={formItem?.readonly}
          controls={false}
          decimalSeparator={decimalSeparator}
          formatter={formatter}
          parser={parser}
        />
      </Form.Item>
    );
  };

  const TextMultiline = () => {
    const rowsMin = Math.ceil(formItem?.max_text_length / 135);
    const rowsMax = Math.ceil(formItem?.max_text_length / 54);

    return (
      <Form.Item
        label={getNameByCode(formItem?.code)}
        name={name}
        className={
          formItem?.min_number_of_submissions === 1
            ? 'custom-required'
            : ''
        }
        rules={[
          {
            required:
              formItem?.min_number_of_submissions === 1,
            message: t('ENTER_DATA'),
          },
        ]}
        required={false}
      >
        <CustomTextarea
          width={'100%'}
          autoSize={{ minRows: rowsMin, maxRows: rowsMax }}
          rows={Math.ceil(rowsMin + rowsMax) / 2}
          placeholder={formItem?.hint}
          minLength={formItem?.min_text_length}
          maxLength={formItem?.max_text_length}
          showCount={true}
        />
      </Form.Item>
    );
  };

  const Confirm = () => {
    return (
      <Form.Item
        name={name}
        normalize={(value) => value ?? false}
        valuePropName="checked"
        className={
          'filter-check-item' +
            formItem?.min_number_of_submissions ===
          1
            ? 'custom-required'
            : ''
        }
        required={false}
      >
        <CustomCheckbox >
          {formItem?.description}
        </CustomCheckbox>
      </Form.Item>
    );
  };

  const File = ({ item, onboardingId }) => {
    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [isLoadingPreview, setIsLoadingPreview] = useState(false);

    const stored = useMemo(() => {
      return onboardingById?.attachment ?? null;
    }, [onboardingById, item?.id]);

    const uploadImage = async(event) => {
      if (deferRemoteSubmit) return;
      const file = event.target.files[0];
      if (!file) return;
      
      if(file.size > item?.max_size_bytes) {
        const errorMsg = t('FILE_SIZE_ERROR') + ` : max size ${item?.max_size_bytes / 1024}kB`;
        setError(errorMsg);
        const timer = setTimeout(() => {
          setError(null);
        }, 3000);
        return () => clearTimeout(timer);
      }
      if(file.size < item?.min_size_bytes) {
        const errorMsg = t('FILE_SIZE_ERROR') + `: min size ${item?.min_size_bytes / 1024}kB`;
        setError(errorMsg);
        const timer = setTimeout(() => {
          setError(null);
        }, 3000);
        return () => clearTimeout(timer);
      }
      const fileToToObject = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const base64Data = reader.result.split(',')[1];
            resolve({
              data: base64Data,
              mime_type: file.type,
              name: file.name
            });
          };
          reader.onerror = (error) => reject(error);
        });
      };

      try {
        const binaryFile = await fileToToObject(file);
        dispatch(uploadOnboardingDocument({path: getPath, id: onboardingId, data: binaryFile}));
      } catch(err) {
        console.error('Error uploading file:', err);
        setError(t('FILE_UPLOAD_ERROR') || 'Error uploading file');
        setTimeout(() => setError(null), 3000);
      }
    };

    const handleClearUpload = () => {
      dispatch(deleteAttachedDocuments({id: onboardingId, path: getPath}));
    };

    const handleDocumentPreview = () => {
      setIsPreviewOpen(true);

      if (stored && !isLoadingPreview) {
        setIsLoadingPreview(true);
        // dispatch(getAttachedDocumentsByPath({id: onboardingId, path: getPath}));
      }
    };

    return (
      <div className="image-upload-wrapper onboarding-upload">
        <h2 className="onboarding-table-title" style={{width: '100%'}}>
          {t(item?.description)}
          {formItem?.min_number_of_submissions === 1
            ? ' *'
            : ''
          }
        </h2>
        {(!stored) &&
        <Button
          type="text"
          disabled={notEditable}
          className="onboarding-upload-btn"
          icon={<Pluse />}
          iconPosition={'end'}
        >
          <input
            type="file"
            accept=".jpg, .jpeg, .png, .pdf, .heic"
            className="item-img-upload"
            onChange={(event) => uploadImage(event)}
          />
          {t('ADD_FILE')}
        </Button>}
        {stored ? (
          <div className="upload-documents-wrapper">
            <div
              key={stored?.name}
              className="name-upload-wrapper upload-documents"
            >
              <Attached />
              <p
                className="name-uploaded"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleDocumentPreview();
                }}
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleDocumentPreview();
                  }
                }}
              >
                {stored?.name}
              </p>
              <DelImage
                disabled={notEditable}
                className="clear-uploaded"
                onClick={notEditable ? undefined : () => handleClearUpload()}
              />
            </div>
          </div>
        ) : (
          <p className="onboarding-upload-filename">
            {item?.hint}
          </p>
        )}
        {error && (
          <p className="onboarding-upload-error">
            {error}
          </p>
        )}
        {isPreviewOpen && (
          <OnboardingFileViewer
            open={isPreviewOpen}
            onClose={() => setIsPreviewOpen(false)}
            fileData={{path: getPath, id: onboardingId}}
            mimeType={stored?.mime_type}
            fileName={stored?.name}
          />)}
      </div>
    );
  };

  File.propTypes = {
    item: PropTypes.shape({
      id: PropTypes.string,
      description: PropTypes.string,
      hint: PropTypes.string,
      max_size_bytes: PropTypes.number,
      min_size_bytes: PropTypes.number,
    }),
    onboardingId: PropTypes.string,
  };

  if (formItem?.type === 'DATE') {
    return <Date />;
  } else if (formItem?.type === 'DATE_TIME') {
    return <DateTime />;
  } else if (formItem?.type === 'LIST_FIXED') {
    return <ListFixed />;
  } else if (formItem?.type === 'TEXT') {
    return <Text />;
  } else if (formItem?.type === 'NONE') {
    return <Typography />;
  } else if (formItem?.type === 'LIST_DYNAMIC') {
    return <ListDynamic />;
  } else if (formItem?.type === 'PHONE_NUMBER') {
    return <Text />;
  } else if (formItem?.type === 'EMAIL') {
    return <Email />;
  } else if (formItem?.type === 'NUMBER') {
    return <Number />;
  } else if (formItem?.type === 'TEXT_MULTILINE') {
    return <TextMultiline />;
  } else if (formItem?.type === 'CONFIRM') {
    return <Confirm />;
  } else if (formItem?.type === 'FILE') {
    return (
      <File
        key={formItem?.code}
        item={formItem}
        onboardingId={onboardingById?.id}
      />
    );
  } else if (formItem?.type === 'URL') {
    return <Url />;
  } else {
    return <div>{formItem?.type}</div>;
  }
};

export default React.memo(OnboardingItemFabrica);

OnboardingItemFabrica.propTypes = {
  form: PropTypes.object,
  formItem: PropTypes.object,
  composite: PropTypes.string,
  multiName: PropTypes.number,
  onChange: PropTypes.func,
  deferRemoteSubmit: PropTypes.bool,
  onDeferredBlur: PropTypes.func,
  getNameByCode: PropTypes.func,
  getPath: PropTypes.string,
  notEditable: PropTypes.bool,
};